import React, { useEffect, useState } from "react";
import "../Zone/Zone.css";
import "./Overview.css";
import { fetchLatestProcedures } from "../../Services/locationEntries";

function fmtDate(ts) {
  if (!ts) return "—";
  const d = ts.toDate ? ts.toDate() : new Date(ts);
  return (
    d.toLocaleDateString("en-GB", { day: "2-digit", month: "short" }) +
    ", " +
    d.toLocaleTimeString("en-GB", { hour: "2-digit", minute: "2-digit", hour12: false })
  );
}

const TYPE_VARIANT = {
  EMPLOYEE: "ok",
  LOGISTICS: "info",
  SENSOR: "warn",
  independentEngineer: "neutral",
};

function HomeProcedures({ className, onBack, onProcedureClick, allowedZones }) {
  const [entries, setEntries] = useState(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    setEntries(null);
    setError(false);
    fetchLatestProcedures(undefined, 10, allowedZones)
      .then(setEntries)
      .catch((err) => { console.error(err); setError(true); });
  }, [allowedZones]);

  return (
    <div className={className} data-cy="home-procedures-screen">
      <div className="subhdr">
        <div className="back" onClick={onBack}>
          <svg viewBox="0 0 24 24">
            <polyline points="15,18 9,12 15,6" />
          </svg>
        </div>
        <div className="subhdr-info">
          <div className="subhdr-crumb">Chennai · All PCTs</div>
          <div className="subhdr-title">Procedures</div>
        </div>
        {entries && !error && (
          <span className="pill neutral">{entries.length}</span>
        )}
      </div>
      <div className="divider" />
      <div className="scroll">
        {entries === null && !error && (
          <div style={{ padding: "24px 20px", fontSize: "var(--text-base)", color: "var(--t3)" }}>Loading…</div>
        )}
        {error && (
          <div style={{ padding: "24px 20px", fontSize: "var(--text-base)", color: "var(--error, #c0392b)" }}>Failed to load procedures.</div>
        )}
        {!error && entries?.length === 0 && (
          <div style={{ padding: "24px 20px", fontSize: "var(--text-base)", color: "var(--t3)" }}>No procedures found.</div>
        )}
        {entries?.length > 0 && (
          <div className="lrows">
            {entries.map((p) => {
              const type = p.procedure?.type;
              const name = p.employee?.name;
              const phone = p.employee?.phoneNumber;
              const pctNo = p.location?.PCTNo;
              return (
                <div key={p.documentId} className="lrow" onClick={() => onProcedureClick && onProcedureClick(p)}>
                  <div className="li">
                    <div className="ln">{p.procedure?.title || "Procedure"}</div>
                    <div className="ls">
                      {pctNo ? `${pctNo} · ` : ""}
                      {name || phone
                        ? `${name || ""}${name && phone ? " · " : ""}${phone || ""}`
                        : fmtDate(p.createdAt)}
                    </div>
                    {(name || phone) && (
                      <div className="ls">{fmtDate(p.createdAt)}</div>
                    )}
                  </div>
                  {type && (
                    <span className={`snap-pill ${TYPE_VARIANT[type] || "neutral"}`} style={{ flexShrink: 0 }}>
                      {type}
                    </span>
                  )}
                </div>
              );
            })}
          </div>
        )}
        <div style={{ height: "20px" }} />
      </div>
    </div>
  );
}

export default HomeProcedures;
